// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert_alert__2ADkD","mobile":"alert_mobile__32ZAp"};